import axios from './biAxios';
import authHeader from "./authentification-header";

const API_URL = "/api/dashboard/";

const getList = (plant, product, area, point) => axios
    .get(`${API_URL}list?plant=${plant ?? ''}&product=${product ?? ''}&area=${area ?? ''}&point=${point ?? ''}`, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));

const allActions = {
    getList,
};

export default allActions;